package com.exura.features.fileStorage.di

import com.exura.features.fileStorage.data.repository.UserFileStorageRepositoryImpl
import com.exura.features.fileStorage.domain.repository.UserFileStorageRepository
import com.exura.features.fileStorage.usecase.ListFilesUseCase
import com.exura.features.fileStorage.usecase.UploadFileUseCase
import org.koin.dsl.module


val fileStorageModule = module {
    single<UserFileStorageRepository> {
        UserFileStorageRepositoryImpl(
            storage = get(),
            getUserFilesPrefixUseCase = get(),
        )
    }

    factory<ListFilesUseCase> { ListFilesUseCase(get()) }
    factory<UploadFileUseCase> { UploadFileUseCase(get()) }
}
